<template>
  <el-dialog :title="title" width="800" v-model="dialogVisible" destroy-on-close>
    <el-form :model="formData" label-width="120" :rules="rules" ref="formRef">
      <el-tabs v-model="innerTabName">
        <el-tab-pane label="基础货品信息" name="basic">
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item prop="storeCode" label="入库库房">
                <el-select v-model="formData.storeCode" placeholder="库房" style="width:180px">
                  <el-option v-for="item in dict.stores" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="channel" label="渠道">
                <el-select v-model="formData.channel" placeholder="渠道" style="width: 180px">
                  <el-option v-for="dd in dict.channels" :key="dd.value" :label="dd.label" :value="dd.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="showSkuSelector">
              <el-form-item prop="brandModelCode" label="选择入库款式">
                <el-autocomplete
                  style="width: 75%"
                  v-model="innerChooseSkuValue"
                  :fetch-suggestions="safeSkuFetchSuggestions"
                  placeholder="选择对应的产品SKU信息"
                  @select="$emit('sku-select', $event)"
                  :disabled="disableSkuSelector"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="detailCode" label="系统款号">
                <el-input v-model="formData.detailCode" disabled style="width:180px;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="skuSerialCode" label="自定义款号">
                <el-input v-model="formData.skuSerialCode" disabled style="width:180px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="detailName" label="款式名称">
                <el-input v-model="formData.detailName" style="width:80%;" :disabled="lockSkuFields" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="brandName" label="品牌名称">
                <el-select v-model="formData.brandName" placeholder="请维护款式品牌信息" style="width:180px" :disabled="lockSkuFields">
                  <el-option v-for="item in dict.brands" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="brandModelCode" label="品牌款号">
                <el-input v-model="formData.brandModelCode" style="width:150px;" :disabled="lockSkuFields" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="factoryName" label="工厂名称">
                <el-select v-model="formData.factoryName" placeholder="请维护款式工厂信息" style="width:180px">
                  <el-option v-for="item in dict.factorys" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="factoryModelCode" label="工厂款号">
                <el-input v-model="formData.factoryModelCode" style="width:150px;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="unitName" label="规格/单位">
                <el-input v-model="formData.unitName" style="width:200px;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="certNumber" label="证书号">
                <el-input v-model="formData.certNumber" style="width:200px;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="serialCode" label="批次号/货号">
                <el-input
                  v-model="formData.serialCode"
                  show-word-limit
                  minlength="4"
                  maxlength="25"
                  style="width:200px;"
                  @input="$emit('serial-input')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="brandSerialCode" label="品牌货号">
                <el-input v-model="formData.brandSerialCode" style="width:200px;" :disabled="lockSkuFields" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="stockNumber" label="入库数量">
                <el-input-number
                  v-model="formData.stockNumber"
                  :min="0"
                  :max="10000000"
                  :precision="2"
                  style="width:145px;"
                  @change="$emit('item-change', { source: 'stockNumber' })"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="克重价格信息" name="golden">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="className" label="计价方式">
                <el-select v-model="formData.className" placeholder="产品计价方式" style="width:180px">
                  <el-option key="按克" label="按克" value="按克"></el-option>
                  <el-option key="按件" label="按件" value="按件"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="weight" label="重量(总重)">
                <el-input-number v-model="formData.weight" :min="0" :max="10000000" :precision="2" style="width:165px;"></el-input-number>
              </el-form-item>
            </el-col>
            <el-divider style="margin-top: 0;" />
            <el-col :span="24"><el-form-item prop="goldWeight" label="金重(克)"><el-input-number v-model="formData.goldWeight" :min="0" :max="2000" :precision="2" style="width:180px;"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="goldInPrice" label="入库金价 (元/克)"><el-input-number v-model="formData.goldInPrice" :min="0" :max="5000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="goldInTaxPrice" label="含税金价 (元/克)"><el-input-number v-model="formData.goldInTaxPrice" :min="0" :max="5000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-col :span="24">
              <el-form-item label="工费(元/克)">
                <el-input-number v-model="formData.laborUnitPrice" :min="0" :max="10000" :precision="2" style="width:180px;" placeholder="克工费(元/克)" @change="$emit('item-change', { source: '' })"></el-input-number>
                <el-input-number v-model="formData.laborPiecePrice" :min="0" :max="100000" :precision="2" style="width:180px; margin:0 15px;" placeholder="件工费(元/件)" @change="$emit('item-change', { source: '' })"></el-input-number>
                <el-text type="success">克工费/件工费，二选一填写</el-text>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="含税工费">
                <el-input-number v-model="formData.laborUnitTaxPrice" :min="0" :max="10000" :precision="2" style="width:180px;" placeholder="含税克工费(元/克)" @change="$emit('item-change', { source: '' })"></el-input-number>
                <el-input-number v-model="formData.laborPieceTaxPrice" :min="0" :max="100000" :precision="2" style="width:180px; margin:0 15px;" placeholder="含税件工费(元/件)" @change="$emit('item-change', { source: '' })"></el-input-number>
              </el-form-item>
            </el-col>
            <el-divider style="margin-top: 0;" />
            <el-col :span="12"><el-form-item prop="stoneBoundPrice" label="镶嵌物费用"><el-input-number v-model="formData.stoneBoundPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="stoneBoundTaxPrice" label="含税镶嵌物费用"><el-input-number v-model="formData.stoneBoundTaxPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="otherPiecePrice" label="其他费用"><el-input-number v-model="formData.otherPiecePrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="otherPieceTaxPrice" label="含税其他费用"><el-input-number v-model="formData.otherPieceTaxPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: '' })"></el-input-number></el-form-item></el-col>
            <el-divider style="margin-top: 0;" />
            <el-col :span="12"><el-form-item prop="unitPrice" label="采购单价"><el-input-number v-model="formData.unitPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: 'unitPrice' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="noTaxPurchasePrice" label="不含税采购价"><el-input-number v-model="formData.noTaxPurchasePrice" :min="0" :max="10000000" :precision="2" style="width:180px;" :disabled="disableFormulaPriceInput" @change="$emit('item-change', { source: 'noTaxPurchasePrice' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="taxPrice" label="税额(金额)"><el-input-number v-model="formData.taxPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" :disabled="disableFormulaPriceInput || disableDerivedPrices"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="purchasePrice" label="含税采购价"><el-input-number v-model="formData.purchasePrice" :min="0" :max="10000000" :precision="2" style="width:180px;" :disabled="disableFormulaPriceInput" @change="$emit('item-change', { source: 'purchasePrice' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="useBrandPrice" label="品牌使用费"><el-input-number v-model="formData.useBrandPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" @change="$emit('item-change', { source: 'useBrandPrice' })"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="productPrice" label="入库价"><el-input-number v-model="formData.productPrice" :min="0" :max="10000000" :precision="2" style="width:180px;" :disabled="disableFormulaPriceInput || disableDerivedPrices"></el-input-number></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="sellPrice" label="计划售价"><el-input-number v-model="formData.sellPrice" :min="0" :max="10000000" :precision="2" style="width:180px;"></el-input-number></el-form-item></el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="其他货品信息" name="other">
          <el-row :gutter="0">
            <el-col :span="12"><el-form-item prop="outOrderNo" label="原发货单号"><el-input v-model="formData.outOrderNo" style="width:220px;" /></el-form-item></el-col>
            <el-col :span="12"><el-form-item prop="platformOrderNo" label="平台单号"><el-input v-model="formData.platformOrderNo" style="width:220px;" /></el-form-item></el-col>
            <el-col :span="24"><el-form-item prop="remark" label="备注"><el-input v-model="formData.remark" style="width:80%;" /></el-form-item></el-col>
            <el-divider />
            <el-col :span="12">
              <el-form-item prop="productionDate" label="生产日期">
                <el-date-picker
                  v-model="formData.productionDate"
                  type="date"
                  placeholder="生产日期"
                  format="YYYY-MM-DD"
                  :editable="false"
                  :disabled-date="date => formData.warrantyExpiryDate ? date.getTime() > new Date(formData.warrantyExpiryDate).getTime() : false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="warrantyExpiryDate" label="有效日期">
                <el-date-picker
                  v-model="formData.warrantyExpiryDate"
                  type="date"
                  placeholder="有效日期（保质期）"
                  format="YYYY-MM-DD"
                  :editable="false"
                  :disabled-date="date => formData.productionDate ? date.getTime() < new Date(formData.productionDate).getTime() : false"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">取 消</el-button>
        <el-button type="primary" @click="confirm" size="large">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "StockBoundEditor",
  emits: ["update:visible", "update:tabName", "update:chooseSkuValue", "confirm", "sku-select", "item-change", "serial-input"],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "货品信息维护" },
    formData: { type: Object, required: true },
    rules: { type: Object, default: () => ({}) },
    dict: { type: Object, default: () => ({ stores: [], channels: [], brands: [], factorys: [] }) },
    tabName: { type: String, default: "basic" },
    chooseSkuValue: { type: String, default: "" },
    showSkuSelector: { type: Boolean, default: true },
    disableSkuSelector: { type: Boolean, default: false },
    lockSkuFields: { type: Boolean, default: false },
    disableDerivedPrices: { type: Boolean, default: false },
    skuFetchSuggestions: { type: Function, default: null },
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); },
    },
    innerTabName: {
      get() { return this.tabName; },
      set(val) { this.$emit("update:tabName", val); },
    },
    innerChooseSkuValue: {
      get() { return this.chooseSkuValue; },
      set(val) { this.$emit("update:chooseSkuValue", val); },
    },
    disableFormulaPriceInput() {
      const className = (this.formData && this.formData.className) || "";
      return className === "按克计价" || className === "按克" || className === "非一口价";
    },
  },
  methods: {
    safeSkuFetchSuggestions(queryString, callback) {
      if (!this.skuFetchSuggestions) {
        callback([]);
        return;
      }
      this.skuFetchSuggestions(queryString, callback);
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.$emit("confirm");
      });
    },
  },
};
</script>
